import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TextField } from "@material-ui/core";
import RegularButton from "components/CustomButtons/Button";
import { useForm } from "hooks/useForm";
import { getStationsByPostalCode } from "redux/actions/customers/customersAction";
import { red } from "@material-ui/core/colors";

export const FormVerifyService = ({ onClose, onConfirm , agentCall}) => {
  const dispatch = useDispatch();
  const { isOpen, message } = useSelector(({ search }) => search);

  const [isBlock, setIsBlock] = useState(false)
  const { inputValues, handleInputOnChange, fieldErrors } = useForm({ postalCode: "" },{ postalCode: {
    exactLength: 5,
    message: 'Se requieren 5 digitos'
   } });
  const { postalCode } = inputValues;
  const verifyService = (e) => {
    e.preventDefault()
    const block = agentCall?.token ? true : false
    dispatch(getStationsByPostalCode(postalCode, onClose, onConfirm, block));
  };

  useEffect(() => {
    postalCode.length === 5 ? setIsBlock(false) : setIsBlock(true)
  }, [postalCode])
  return (
    <form
      onSubmit={verifyService}
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 8,
        alignItems: "center",
      }}
    >
      <TextField
      variant="outlined"
        label="Codigo postal"
        name="postalCode"
        value={postalCode}
        onChange={handleInputOnChange}
        fullWidth
        style={{ textAlign: "center" }}
        helperText={fieldErrors.postalCode || ""}
        inputProps={{ style: { textAlign: "center" } }}
      />
      {
        isOpen && <p style={{color: red[500]}}>{message}</p>
      }
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: 8,
        }}
      >
        <RegularButton color="transparent" onClick={onClose}>
          Cancelar
        </RegularButton>
        <RegularButton type="submit" color="success" onClick={verifyService} disabled={isBlock} >
          Verificar Servicio
        </RegularButton>
      </div>
    </form>
  );
};
